import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../../../Components/base/sidebar';
import ActionBar from '../../../Components/Button/ActionBar';
import SEOForm from '../../../Components/Forms/SEOForm';
import StoryDetails from '../../../Components/Forms/StoryDetails';
import Delete from '../../../Components/Button/Delete';
import CreateTicketPriceForm from '../../../Components/Forms/CreateTicketGroupForm';

interface Item {
    ticket_id: number;
    ticket_group_code: string;
    ticket_notes: string;
    // Add more properties as per your item structure
}

export default function TicketPricesEditor() {
    const location = useLocation();
    const id = location.state && location.state.id;
    const [tier, setTier] = useState<string[]>(['']);
    const [currency, setCurrency] = useState('');
    const [amount, setAmount] = useState<string[]>(['']);
    const [ticket_group_code, setTicketGroupCode] = useState('');
    const [ticket_notes, setTicketNotes] = useState('');
    const [items, setItems] = useState<Item[]>([]);
    const [item, setItem] = useState<any | null>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [postID, setPostID] = useState<string | null>(null);
    const [role, setRole] = useState<string | null>(null);
    const isMounted = useRef(true);


    useEffect(() => {
        const id = location.state && location.state.id;
    }, []);

    useEffect(() => {
        isMounted.current = true;
        const fetchData = async () => {
            try {
                const response = await axios.get('https://cdn.pulp.ph/api/v1/pulpliveworld/ticket', {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    }
                });
                if (isMounted.current) {
                    setItems(response.data.ticket);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
        return () => {
            isMounted.current = false;
        };
    }, []);

    const handleTicketGroupCodeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setTicketGroupCode(e.target.value);
    };

    const handleTierChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const newTier = [...(tier || [])];
        newTier[index] = e.target.value;
        setTier(newTier);
    };

    const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const newAmount = [...(amount || [])];
        newAmount[index] = e.target.value;
        setAmount(newAmount);
    };

    const handleCurrencyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCurrency(e.target.value);
    };

    const handleTicketNotesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTicketNotes(e.target.value);
    };

    const handleAddMore = () => {
        setTier([...tier, '']);
        setAmount([...amount, '']);
    };

    const handleRemove = (index:number) =>{
        const updatedTier = tier.filter((_, i) => i !== index);
        const updatedAmount = tier.filter((_, i) => i !== index);
        setTier(updatedTier);
        setAmount(updatedAmount);
    };


    const navigate = useNavigate();

    // const autosave = async () => {
    //     const formData = new FormData();
    //     formData.append('category', category);
    //     formData.append('sub_category', sub_category);
    //     formData.append('title', title);
    //     formData.append('body', body);
    //     formData.append('seo_title', seo_title);
    //     formData.append('description', description);
    //     formData.append('sub_head', sub_head);
    //     formData.append('photo_by', photo_by);
    //     if (image) {
    //         formData.append('image', image);
    //     }
    //     if (imageUrl) {
    //         formData.append('imageUrl', imageUrl);
    //     }

    //     try {
    //         const authToken = localStorage.getItem('authToken');
    //         if (!authToken) {
    //             return;
    //         }

    //         if (postID) {
    //             await axios.post(`https://cdn.pulp.ph/api/v1/community/save/${postID}`, formData, {
    //                 headers: {
    //                     'Content-Type': 'multipart/form-data',
    //                     Authorization: `Bearer ${authToken}`,
    //                 }

    //             }
    //             );
    //         } else {
    //             const response = await axios.post(`https://cdn.pulp.ph/api/v1/save/community`, formData, {
    //                 headers: {
    //                     'Content-Type': 'multipart/form-data',
    //                     Authorization: `Bearer ${authToken}`,
    //                 }
    //             });
    //             setPostID(response.data.id);
    //         }

    //         setIsSaved(false);

    //     } catch (error) {
    //         console.error('Unable to Autosave Form!', error);
    //     } finally {
    //         setTimeout(() => {
    //             setIsSubmitting(false);
    //         }, 3000);
    //     }
    // };

    // useEffect(() => {
    //     const handler = setTimeout(() => {
    //         autosave();
    //     }, 2000);

    //     return () => {
    //         clearTimeout(handler);
    //     };
    // }, [category, sub_category, title, body, seo_title, description, sub_head, photo_by, image, imageUrl]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);

        const formData = new FormData();
        formData.append('ticket_group_code', ticket_group_code);
        tier.forEach((value) => formData.append('tier[]', value));
        formData.append('currency', currency);
        amount.forEach((value) => formData.append('amount[]', value));

        try {
            const authToken = localStorage.getItem('authToken');
            if (!authToken) {
                alert('Authentication token not found!');
                setIsSubmitting(false);
                return;
            }

            if (postID) {
                await axios.post(`https://cdn.pulp.ph/api/v1/pulpliveworld/ticket-group/${postID}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Bearer ${authToken}`,
                    }
                });
            } else {
                const response = await axios.post(`https://cdn.pulp.ph/api/v1/pulpliveworld/ticket-group`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Bearer ${authToken}`,
                    }
                });
                setPostID(response.data.id);
            }
            alert('Content Submitted Successfully !!');
            navigate('/view/post/ticket-prices');
        } catch (error) {
            console.error('There was an error submitting the form!', error);
            alert(`There was an error submitting the form!, ${error}`);
        } finally {
            setTimeout(() => {
                setIsSubmitting(false);
            }, 3000);
        }
    };
    // const handleSaveDraft = async () => {
    //     setIsSubmitting(true);

    //     const formData = new FormData();
    //     formData.append('category', category);
    //     formData.append('sub_category', sub_category);
    //     formData.append('title', title);
    //     formData.append('body', body);
    //     formData.append('seo_title', seo_title);
    //     formData.append('description', description);
    //     formData.append('sub_head', sub_head);
    //     formData.append('photo_by', photo_by);
    //     if (image) {
    //         formData.append('image', image);
    //     }
    //     if (imageUrl) {
    //         formData.append('imageUrl', imageUrl);
    //     }

    //     try {
    //         const authToken = localStorage.getItem('authToken');
    //         if (!authToken) {
    //             alert('Authentication token not found!');
    //             setIsSubmitting(false);
    //             return;
    //         }

    //         if (postID) {
    //             await axios.post(`https://cdn.pulp.ph/api/v1/community/save/${postID}`, formData, {
    //                 headers: {
    //                     'Content-Type': 'multipart/form-data',
    //                     Authorization: `Bearer ${authToken}`,
    //                 }
    //             });
    //         } else {
    //             const response = await axios.post(`https://cdn.pulp.ph/api/v1/community`, formData, {
    //                 headers: {
    //                     'Content-Type': 'multipart/form-data',
    //                     Authorization: `Bearer ${authToken}`,
    //                 }
    //             });
    //             setPostID(response.data.id);
    //         }
    //         alert('Draft Saved Successfully !!');
    //     } catch (error) {
    //         console.error('There was an error saving the draft!', error);
    //         alert(`There was an error saving the draft!, ${error}`);
    //     } finally {
    //         setIsSubmitting(false);
    //     }
    // };

    const handleViewShortstory = async () => {
        try {
            if (postID) {
                window.open(`https://pulpmagazine.com/article/community/${postID}`, '_blank');
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        const storedRole = localStorage.getItem('role');
        setRole(storedRole);
    }, []);

    const handleDelete = async () => {
        try {
            const authToken = localStorage.getItem('authToken');
            if (!authToken) {
                // Handle the case where authToken is not available
                alert('Authentication token not found!');
                return;
            }

            const confirmDelete = window.confirm('Are you sure you want to delete this content?');
            if (!confirmDelete) {
                return; // If user cancels, do nothing
            };

            if (id) {
                await axios.delete(`https://cdn.pulp.ph/api/v1/pulpliveworld/ticket-group/${id}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    }
                })
            };
            alert('Content Deleted Successfully !!');// Handle success (e.g., show a success message or redirect)
            navigate('/view/post/ticket-prices')
        } catch (error) {
            console.error('There was an error submitting the form!', error);
            // Handle error (e.g., show an error message)
        }
    };

    return (
        <>
            <div className="w-full">
                <div className='Dashboard-container flex place-content-between'>
                    <h1 className='mt-5 font-semibold'>Ticket Prices Editor</h1>
                    <ActionBar
                        role={role}
                        onSubmit={handleSubmit}
                        onView={handleViewShortstory}
                        isSubmitting={isSubmitting}
                        isSaved={isSubmitting}
                    />
                </div>
                <div className='container mt-5 pt-5 px-4 rounded bg-white'>
                    <CreateTicketPriceForm
                        ticket_group_code={ticket_group_code}
                        ticket_notes={ticket_notes}
                        items={items}
                        tier={tier}
                        currency={currency}
                        amount={amount}
                        onTicketNotesChange={handleTicketNotesChange}
                        onTicketGroupCodeChange={handleTicketGroupCodeChange}
                        onTierChange={handleTierChange}
                        onCurrencyChange={handleCurrencyChange}
                        onAmountChange={handleAmountChange}
                        onAddMore={handleAddMore}
                        onDelete={handleRemove}
                    />


                    {/* onClick={() => handleDelete(item.id)} */}
                </div>
            </div>
        </>
    );
}
